// utils/deviceDetect.js

// Function to detect if the user is on an iOS device
export const isIOS = () => {
    // Regular expression to match iPad, iPhone, or iPod in the user agent string
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };
  